import {getViewSettingsSafely, UserViewSettings} from "./ViewSettings";
import {currentLanguageFromStore, Language} from "../../config/LanguageConfig";
import { AppState } from "../../reducers/RootReducer";
import { StateObservable } from "redux-observable";
import {APP_CONFIG} from "../../config/GeneralConfig";
import {getUrlParamsFromViewSettings} from "../../config/RouteConfig";

export interface ApiReturnType< T > {
    totalEntries: number
    entries: T
}

export interface ApiReturnTotalsType< T, X > extends ApiReturnType<T> {
    totals: X
}

export interface ApiFetchError< T > {
    type: T
    error: Error
} 

export interface ServerMessageEvent {
    data: string
}

export interface ApiRouteableProp {
    route: string
}

export interface UserViewSettingsApiRequest {
    path: string
    userViewSettings: UserViewSettings
}


/**
 * retrieves the user view settings for the specified view from redux store
 * returns the given uri with added url params
 *
 * @param uri the api url to call, MUST end with a slash "/"
 * @param viewIdentifier
 * @param store$
 */
export function getUserViewSettingsApiRequest(
    uri: string,
    viewIdentifier: string,
    store$: StateObservable<AppState>
): UserViewSettingsApiRequest
{
    const userViewSettings = getViewSettingsSafely( viewIdentifier, store$ );
    const path = `${ uri }${  getUrlParamsFromViewSettings( userViewSettings) }`;

    return { path, userViewSettings };
}

export interface FileRequestProp {
    files: File[]
}